__turbopack_context__.v({
  "Actions": "_index-module__HY-a5a__Actions",
  "Backdrop": "_index-module__HY-a5a__Backdrop",
  "Button": "_index-module__HY-a5a__Button",
  "Container": "_index-module__HY-a5a__Container",
  "Description": "_index-module__HY-a5a__Description",
  "Intro": "_index-module__HY-a5a__Intro",
  "Popup": "_index-module__HY-a5a__Popup",
  "Title": "_index-module__HY-a5a__Title",
});
